import { Injectable } from "@angular/core";
declare var XLSX: any;
@Injectable({
    providedIn: "root",
})
export class DataExportService {
    constructor() {}

    exportToExcel(docs, columns, fileName) {
        const documents = docs;
        const excelData = [];
        const exportCols = columns;
        const headers = columns.map((col) => col.name);
        excelData.push(headers);
        documents.forEach((item) => {
            const dataRow = [];
            columns.forEach((col) => {
                dataRow.push(item[col.colKey]);
            });
            excelData.push(dataRow);
        });
        const filename = fileName + ".xlsx";
        /* Sheet Name */
        const ws_name = "Data";
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        /* Add worksheet to workbook */
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        /* Write workbook and Download */
        XLSX.writeFile(wb, filename);
        return;
    }
}
